import { LGEElectionStatusEnum } from "../enums/LGEElectionStatusEnum";
import { LGEResultsStatusEnum } from "../enums/LGEResultsStatusEnum";
import { ILGEChangeElection } from "../interfaces/ILGEChangeElection";
import { ILGEStaticElection } from "../interfaces/ILGEStaticElection";
import { LGCandidate } from "./LGCandidate";


export class LGElection {
    private readonly _lgeChangeElection: ILGEChangeElection | null;
    private readonly _lgeStaticElection: ILGEStaticElection;
  
    public candidates: LGCandidate[] = [];
    constructor(
        lgeChangeElection: ILGEChangeElection | null,
        lgeStaticElection: ILGEStaticElection
    ) {
        this._lgeChangeElection = lgeChangeElection;
        this._lgeStaticElection = lgeStaticElection;

        this._lgeStaticElection.candidates.forEach(candidate => {
            const foundLGEChangeCandidate = this._lgeChangeElection?.candidates.find(candidateItem => candidateItem.uid === candidate.uid);
            this.candidates.push(new LGCandidate(foundLGEChangeCandidate ? foundLGEChangeCandidate : null, candidate));
        });

        if (this._lgeStaticElection.electionStatus !== LGEElectionStatusEnum.election) {
            this.candidates.sort((a, b) => a.candidateName < b.candidateName ? -1 : 1);
        }

    }

    get uid(): string {
        return this._lgeStaticElection.uid;
    }   


    get hasResults(): boolean {
        return this._lgeChangeElection !== null ?? false;
    }

    get electionName(): string {
        return this._lgeStaticElection.electionName;
    }   

    get electionCode(): string {
        return this._lgeStaticElection.electionCode;
    }   

    get electionLine(): string {
        return this._lgeStaticElection.electionLine;    
    }

    get electionStatus(): LGEElectionStatusEnum {
        return this._lgeStaticElection.electionStatus;
    }

    get electionResultStatus(): LGEResultsStatusEnum {
        return this._lgeChangeElection?.electionResultsStatus ?? LGEResultsStatusEnum.noResults;
    }

    get vacancies(): number {    
        return this._lgeStaticElection.vacancies;
    }

    get candidateCount(): number {
        return this._lgeStaticElection.candidates.length;
    }

    get unfilled(): number {
        return this.vacancies - this.candidateCount > 0 ? this.vacancies - this.candidateCount : 0;
    }

    get ballotPapersInformal(): number {
        return this._lgeChangeElection?.informalBallotCount ?? 0;
    }

    get scrutinySheetUrl(): string {
        return this._lgeChangeElection?.scrutinySheetUrl ?? '';
    }

    get ballotPapersFormal(): number {
        return this._lgeChangeElection?.candidates
            .reduce((sum, current) => sum + current.firstPrefVotes, 0) ?? 0;
    }

    get quota(): number {
        return this._lgeChangeElection?.quota ?? 0;
    }

    get declarationDate(): Date | null {
        return this._lgeChangeElection?.declarationOn ?? null;
    }

}